import React from 'react'
import { useTranslation } from 'react-i18next';

function BannerVideo() {

const { t } = useTranslation();

  return (
    <section className='sec--area banner-video'>
      <div className='container'>
          <h2 className='w_color text-center f_700 mb-5'>{t("banner_accion.banner_video_title")}</h2>
        <div className='row align-items-center justify-content-center'>
            <div className='col-lg-6 video-1'>
              <div className="video_content mt-2">          
                <iframe className='video_info' 
                        frameBorder="0" 
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  
                        title="Sueña para transformar el futuro." 
                        width="100%" 
                        height="360" 
                        src="https://www.youtube.com/embed/KWcKeJDUriY?si=X0JdDPHM4e2sPkW6" >
                </iframe>  
              </div>  
            </div>
            <div className='col-lg-6 video-2'>
              <div className="video_content mt-2">          
                <iframe className='video_info ' 
                        frameBorder="0" 
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  
                        title="Sueña para transformar el futuro." 
                        width="100%" 
                        height="360" 
                        src="https://www.youtube.com/embed/ScKSFTdSpnA?si=pAU4BHZW7Zfdxph-" >
                </iframe>  
              </div>  
            </div>
        </div>
        </div>
      
      
    </section>
  )
}

export default BannerVideo;